/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @angular-eslint/prefer-inject */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DefectHistoryModel } from '../models/defect-history.model';
import { PageEvent } from 'node_modules/@angular/material/types/_paginator-chunk';
import {
  PanelBodyComponent,
  PanelContainerComponent,
  PanelHeaderComponent,
} from 'src/app/shared/content-panels';
import { DefectHistoryConstants } from '../models/constants/defect-history.constants';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { DateRangeDialogComponent } from 'src/app/shared/dialogs/date-range-dialog/date-range-dialog';
import { MatDialog } from '@angular/material/dialog';
import { DefectHistoryService } from '../services/defect-history.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';

@Component({
  selector: 'app-defect-list-view',
  imports: [
    PanelBodyComponent,
    PanelContainerComponent,
    PanelHeaderComponent,
    CommonModule,
    MatTableModule,
    MatIconModule
  ],
  templateUrl: './defect-list-view.component.html',
  styleUrl: './defect-list-view.component.scss',
})
export class DefectListViewComponent {
  @Input() isDetailOpen = false;
  @Input() activeSerial: DefectHistoryModel | null = null;
  @Input() materialPageIndex = 0;
  @Input() shouldClearSearch = false;
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Output() selectedSerial = new EventEmitter<DefectHistoryModel | null>();
  @Output() pageChange = new EventEmitter<PageEvent>();

  dataSource: DefectHistoryModel[] = [];
  tableTitle = "";
  tableTitleCollapsed = "";
  tableColumns = [
    'serialNumber',
    'zoneName',
    'creationDate',
    'status',
    'defectCount',
  ];
  facilityNumber = "";
  facilityName = "";
  dataRange = "";

  constructor(
    public defectConstants: DefectHistoryConstants,
    private dialog: MatDialog,
    private defectHistoryService: DefectHistoryService,
    private spinnerService: SpinnerService
  ) {}

  ngOnInit() {
    this.spinnerService.show();
    //get facility info
    const facilityData = localStorage.getItem('userFacilities');
    if (facilityData) {
      const facilities = JSON.parse(facilityData);
      const primary = facilities[0]; // or find where IsDefault === true
      this.facilityNumber = primary?.Facility?.KeyChain?.LegacyId ?? '';
      this.facilityName = primary?.Facility?.Name ?? '';
      this.tableTitleCollapsed = `${this.facilityNumber}(${this.facilityName})`;
      this.tableTitle = `${this.facilityNumber}(${this.facilityName}) - ${this.startDate ? this.startDate.toLocaleDateString('en-US') : ''} - ${this.endDate ? this.endDate.toLocaleDateString('en-US') : ''}`;
    }

    this.defectHistoryService.defectHistoryData$.subscribe(data => {
      this.dataSource = data;
      this.spinnerService.hide();
    });

    this.getDefectHistoryData(this.facilityNumber, this.startDate, this.endDate);

  }

  //pulls defect history data from backend
  getDefectHistoryData(facilityNumber: string, startDate: Date | null, endDate: Date | null) {
    if (!startDate || !endDate) {
      this.spinnerService.hide();
      return;
    }

    this.defectHistoryService.getDefectHistory(
      facilityNumber,
      startDate.toISOString(),
      endDate.toISOString()
    );
  }

  //TODO -- make sure all data is passed/formatted correctly
  //will add back in once detail data ticket is complete
  rowSelected(serialNumber: string) {
    // this.activeSerial = this.dataSource.find(item => item.SerialNumber === serialNumber) || null;
    // this.isDetailOpen = true;
    // this.selectedSerial.emit(this.activeSerial);
  }

  openDateRangeDialog() {
    const dialogRef = this.dialog.open(DateRangeDialogComponent, {
      data: { id: 2, startDate: this.startDate, endDate: this.endDate }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.startDate = result.startDate ? new Date(result.startDate) : null;
        this.endDate = result.endDate ? new Date(result.endDate) : null;
        this.tableTitle = `${this.facilityNumber}(${this.facilityName}) - ${this.startDate?.toLocaleDateString('en-US') ?? ''} - ${this.endDate?.toLocaleDateString('en-US') ?? ''}`;
        this.getDefectHistoryData(this.facilityNumber, this.startDate, this.endDate);
      }
    });
  }

}
